import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import Typography from '@lib/components/Typography/Typography';
import styles from './AiDetectingPlaceholder.module.scss';

type Props = {
  // The "Generating description…" / "Detecting…" copy for the field.
  label: string;
};

// Muted placeholder shown while a documentation field is being detected by AI
// (QUEUED/DETECTING) or while a manual Try-again is in flight.
export default function AiDetectingPlaceholder({ label }: Props) {
  return (
    <span className={styles.root}>
      <CircleLoader size={16} strokeWidth={2} padding={0} />
      <Typography variant="body" className={styles.label}>
        {label}
      </Typography>
    </span>
  );
}
